import React from 'react'

import { Field } from 'formik'

import { Col, Form, Button } from '_zari/core'

import { OrigenesContabilidadConstant } from 'constants/index'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'

import { CrudPlantillasModal } from 'sharedComponents/modals'

const PlantillaCanjeFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, vTipoSocio }) => {
  const [plantillasOptions, setPlantillasOptions] = React.useState([])
  const [mostrarCrudPlantillaModal, setMostrarCrudPlantillaModal] = React.useState(false)

  const refrescarSelect = React.useCallback(() => {
    PlantillaContabilidadService.getxOrigenAsSelect(OrigenesContabilidadConstant.CANJE_LETRAS, vTipoSocio).then(
      ({ data }) => {
        if (data && data.length > 0) {
          const primeraOpcion = data[0]
          setFieldValue('_idPlantillaCanje', primeraOpcion._id)

          setPlantillasOptions(
            data.map((x, k) => (
              <option key={k} value={x._id}>
                {x.descripcion}
              </option>
            ))
          )
        }
      }
    )
  }, [setFieldValue, vTipoSocio])

  React.useEffect(() => {
    refrescarSelect()
  }, [refrescarSelect])

  return (
    <>
      <Form.Group>
        <Form.Label text='PLANTILLA' htmlFor='select-plantillaCanje' md={4} alignRightAt='md' />
        <Col md={8}>
          <Form.InputGroup>
            <Field name='_idPlantillaCanje'>
              {({ field }) => (
                <Form.Select {...field} id='select-plantilla' isInvalid={iTouched && iError} disabled={fIsSubmitting}>
                  <option value=''>Seleccionar</option>
                  {plantillasOptions}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarCrudPlantillaModal(true)}>O</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarCrudPlantillaModal && (
        <CrudPlantillasModal
          handleClose={() => {
            setMostrarCrudPlantillaModal(false)
            refrescarSelect()
          }}
          origen={OrigenesContabilidadConstant.CANJE_LETRAS}
          show={mostrarCrudPlantillaModal}
        />
      )}
    </>
  )
}

export default React.memo(PlantillaCanjeFormGroup)
